import { render, staticRenderFns } from "./TabelaResultadosOcorrenciasUsuario.vue?vue&type=template&id=168fa8fc&scoped=true&"
import script from "./TabelaResultadosOcorrenciasUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosOcorrenciasUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosOcorrenciasUsuario.vue?vue&type=style&index=0&id=168fa8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168fa8fc",
  null
  
)

export default component.exports